import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import { PARTICIPATION_STEPS } from '@/mocks/arrangement';
import ArrangementHero from '@/pages/arrangement/components/ArrangementHero';
import StepsSection from '@/pages/arrangement/components/StepsSection';
import AgendaSection from '@/pages/arrangement/components/AgendaSection';
import AwardsSection from '@/pages/arrangement/components/AwardsSection';
import RulesSection from '@/pages/arrangement/components/RulesSection';

export default function Arrangement() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '爆料大赛活动安排 - 参赛方式、奖项设置与评审规则',
        description:
          '爆料大赛活动安排说明，包含报名提交四步流程、各阶段具体安排、六个奖项的设置以及评审与参赛规则。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '活动安排', item: '/arrangement' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'HowTo',
        name: '如何参加爆料大赛',
        description: '从注册报名到进入初赛公投的四个步骤。',
        step: PARTICIPATION_STEPS.map((s, i) => ({
          '@type': 'HowToStep',
          position: i + 1,
          name: s.title,
          text: s.text,
        })),
      },
    ],
    [],
  );

  usePageMeta({
    title: '爆料大赛活动安排 - 参赛方式、奖项设置与评审规则',
    description:
      '爆料大赛活动安排全说明：报名提交四步流程、七个阶段的具体安排、金银铜奖与三个单项奖的设置，以及原创、刷票、申诉等评审参赛规则。',
    keywords: '爆料大赛活动安排,爆料大赛赛程,爆料大赛比赛进度,爆料大赛日程',
    path: '/arrangement',
    jsonLd,
  });

  return (
    <SiteLayout>
      <ArrangementHero />
      <StepsSection />
      <AgendaSection />
      <AwardsSection />
      <RulesSection />

      <section className="w-full px-4 md:px-6 pb-16 md:pb-24 bg-background-50">
        <div className="max-w-6xl mx-auto rounded-lg border border-background-200 bg-background-100 px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">还有疑问？先看常见问题</h2>
            <p className="mt-2 text-sm text-foreground-600">
              关于时间口径、投票权重、公示与申诉的高频问题都整理在常见问题页。
            </p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0">
            <Link
              to="/faq"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              查看常见问题
            </Link>
            <Link
              to="/schedule"
              className="px-6 py-3 rounded-md border border-background-300 text-foreground-700 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
            >
              返回赛程时间表
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}